// @flow

import * as React from 'react';
import '../App.css';
import 'antd/dist/antd.css';
import {Layout, Menu} from 'antd';
import type {History} from 'react-router';
import MenuBar from './menu';
import {withRouter} from 'react-router';

const {Header, Content} = Layout;

type Props = {
  children: React.Node,
  history: History
};

function MainContainer({children, history}: Props): React.Node {
  return (
    <Layout>
      <Header className="header">
        <div className="logo"/>
        <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
          <Menu.Item
            onClick={() => history.push('/')}
            key="1"
          >Guardian Tales Database</Menu.Item>
        </Menu>
      </Header>
      <Layout>
        <MenuBar/>
        <Layout style={{padding: '0 24px 24px'}}>
          <Content
            className="site-layout-background"
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default withRouter(MainContainer);
